import { csvUtils } from '../../../utils'
import { truncateSelectedValues } from './utils'

const { isCSV, mapCSV, parseCSV } = csvUtils

type MakesMapping = {
  makes: Record<string, string | undefined>
  models: Record<string, string | undefined>
  variants: Record<string, string | undefined>
}

const mapFormattedMake = (make: string, mappings: MakesMapping) => {
  const output = mappings.makes[make.toUpperCase()] ?? make
  return output
}

export const getFormattedMake = (make = '', mappings: MakesMapping) =>
  isCSV(make)
    ? mapCSV(make, (part: string) => mapFormattedMake(part, mappings))
    : mapFormattedMake(make, mappings)

const mapFormattedModel = (model: string, mappings: MakesMapping) =>
  mappings.models[model.toUpperCase()] ?? model

export const getFormattedModel = (model = '', mappings: MakesMapping) =>
  isCSV(model)
    ? mapCSV(model, (part: string) => mapFormattedModel(part, mappings))
    : mapFormattedModel(model, mappings)

const mapFormattedVariant = (variant: string, mappings: MakesMapping) => {
  const uppercaseVariant = variant.toUpperCase()
  return mappings.variants[uppercaseVariant] ?? variant
}

export const getFormattedVariant = (variant = '', mappings: MakesMapping) =>
  isCSV(variant)
    ? truncateSelectedValues(
        parseCSV(variant).map((element) =>
          mapFormattedVariant(element, mappings),
        ),
      )
    : mapFormattedVariant(variant, mappings)
